export const Alert = {
  baseStyle: {
    container: {
      borderRadius: 'md',
      borderWidth: '1px',
      borderStyle: 'solid',
    },
  },
  variants: {
    subtle: ({ colorScheme: c }: { colorScheme: string }) => {
      const bgColor = `${c}.50`;
      const borderColor = `${c}.500`;
      const iconColor = `${c}.800`;
      const textColor = `${c}.800`;
      return {
        container: {
          bg: bgColor,
          borderColor: borderColor,
        },
        icon: { color: iconColor },
        spinner: { color: iconColor },
        title: { color: textColor },
        description: { color: textColor },
      };
    },
  },
};
